import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import { Box } from "@mui/material";
import { Outlet } from "react-router";
import { api } from "../../api/client";
import type { ClientDictionaries } from "../../api/types/settingsTypes";
import { SettingsContextProvider } from "./SettingsContext";

const emptyDictionaries: ClientDictionaries = {
  countries: [],
  states: [],
  currencies: [],
  industriesAndSectors: [],
  geographies: [],
};

const SettingsPage = () => {
  const [accessCategories, accessCategoriesError, { isFetching: isFetchingAccessCategories }] = useFetch(
    api.settings.getAccessCategories
  );

  const [dictionaries, dictionariesError, { isFetching: isFetchingDictionaries }] = useFetch(
    api.dictionaries.getDictionaries
  );

  if (accessCategoriesError || dictionariesError) {
    logError(accessCategoriesError || dictionariesError, "[Settings]");
    return <DataLoadingFailed title="Failed to load settings" />;
  }

  return (
    <SettingsContextProvider
      accessCategories={accessCategories ?? []}
      dictionaries={dictionaries ?? emptyDictionaries}
      loading={isFetchingAccessCategories || isFetchingDictionaries}
    >
      <Box sx={{ width: "100%", display: "flex", flexDirection: "column", flex: 1, overflowY: "auto" }}>
        <Outlet />
      </Box>
    </SettingsContextProvider>
  );
};

export default SettingsPage;
